import { Component, OnInit } from '@angular/core';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultaComposta } from 'src/app/models/consulta-composta';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, first } from 'rxjs/operators';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { LoginService } from 'src/app/services/login.service';
import { Usuario } from 'src/app/models/usuario-login';

@Component({
  selector: 'app-list-consulta-composta',
  templateUrl: './list-consulta-composta.component.html',
  styleUrls: ['./list-consulta-composta.component.scss']
})
export class ListConsultaCompostaComponent implements OnInit {

  usuario: Usuario;
  listaCompostas: ConsultaComposta[] = [];
  listaCombinada: ConsultaComposta[] = [];

  combinada: boolean;

  nomeTipo: string;

  unidadeSelecionada: any;
  idUnidade: any;
  uuidUnidade: any;
  listaUnidades = [];
  unidade: boolean;
  login: any;

  first: number = 0;
  consulta: any = {};

  cols: any = [
    { field: 'nome', header: 'Nome' },
  ];

  inputUnidadeFormat = (u) => u.nomeFantasia;
  pesquisaUnidade = (text: Observable<string>) =>
    text.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.listaUnidades.filter(
        c => c.nomeFantasia.toLowerCase().indexOf(term.toLowerCase()) > -1
      ).slice(0, 10))
    );

  constructor(
    private consultaService: ConsultaService,
    private modalService: NgbModal,
    private modalMsgService: ModalMsgService,
    private loginService: LoginService,
    private activatedRoute: ActivatedRoute,
    private unidadeService: UnidadeService,
    private router: Router
  ) {

    this.combinada = this.activatedRoute.snapshot.data['combinada'];
    this.nomeTipo = this.combinada ? 'combinada' : 'composta';

    this.loginService.getLogIn().pipe(first()).subscribe(l => this.usuario = l);
    this.unidadeService.getListaUnidadeNomeFantasia().then(r => this.listaUnidades = r);
    this.unidade = this.activatedRoute.snapshot.data['unidade'] || false;
    if (!this.unidade)
      this.loginService.getLogIn().pipe(first()).subscribe(l => {
        this.login = l;
        this.uuidUnidade = this.login.unidade.uuid;
        this.idUnidade = this.login.unidade.id;
        this.getListaConsultas();
      });
  }

  ngOnInit() {
  }

  getListaConsultas() {
    if (this.unidade)
      this.consultaService.listaConsultaCompostaUnidade(this.idUnidade).then(c => this.listaCompostas = c);
    else {
      if (this.combinada) {
        this.consultaService.listaConsultaCombinada().then(c => this.listaCompostas = c.filter(e => e.idUnidade === this.idUnidade));
      }

      if (!this.combinada) {
        this.consultaService.listaConsultaComposta().then(c => this.listaCompostas = c);
      }
    }
  }

  addFiltroUnidade($event) {
    this.uuidUnidade = $event.item.uuid;
    this.idUnidade = $event.item.id;
    this.getListaConsultas();
  }

  mudarStatusUsuario($event, u) {
    u.status = $event;
  }

  removeFiltroUnidade() {
    this.unidadeSelecionada = '';
    this.listaCompostas = [];
    this.idUnidade = null;
  }

  editarComposta(params) {
    if (this.unidade) {
      let uuid = params.uuid;
      this.router.navigate(['unidade', 'consulta-composta', 'editar', this.uuidUnidade, uuid]);
    } else {

      if (params.combinada == true) {
        let uuid = params.uuid;
        this.router.navigate(['consulta', 'combinada', 'editar', uuid]);
        // this.router.navigate(['consulta', this.combinada ? 'combinada' : 'composta', 'editar', id]);
      }
      if (params.combinada != true) {
        let uuid = params.uuid;
        this.router.navigate(['consulta', 'composta', 'editar', uuid]);
        // this.router.navigate(['consulta', this.combinada ? 'combinada' : 'composta', 'editar', id]);
      }

    }
  }

  adicionarComposta() {
    if (this.unidade) {
      this.router.navigate(['unidade', 'consulta-composta', 'adicionar', this.uuidUnidade]);
    } else {
      this.router.navigate(['consulta', this.combinada ? 'combinada' : 'composta', 'adicionar']);
    }

  }

  delete(consulta) {

    let data = {
      combinada: consulta.combinada,
      id: consulta.id,
      uuid: consulta.uuid,
      nome: consulta.nome,
      status: consulta.status
    }

    this.modalMsgService.open('Deseja excluir a consulta ' + this.nomeTipo + ' selecionada?', '', 'warning').then(result => {
      if (result === 'ok') {
        const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
        modalRef.componentInstance.cabecalho = 'Excluir consulta ' + this.nomeTipo;
        modalRef.result.then(result => {
          if (result) {
            this.consultaService.excluirComposta(data, result).then(result => {
              this.getListaConsultas();
            });
          }
        });
      }
    }).catch(result => result);

  }

}
